import PropTypes from "prop-types";

import {
  Grid,
  Card,
  CardContent,
  CardActions,
  Typography,
  Box,
} from "@material-ui/core";

import { getContentStatus } from "../../consts/assignedContentStatus";
import { useStyles } from "./styles";

export const MoneyHack = ({ data, assignedContent }) => {
  const classes = useStyles();
  return (
    <Grid item xs={12} className={classes.paper}>
      <Card className={classes.root}>
        <CardActions disableSpacing className={classes.cardHeader}>
          <Grid container>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Typography variant="subtitle1">{data.title}</Typography>
            </Grid>
          </Grid>
        </CardActions>
        <CardContent className={classes.cardContent}>
          <Box marginBottom={1}>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Typography variant="subtitle2" align="left">
                Category
              </Typography>
            </Grid>
          </Box>
          <Box marginBottom={2}>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Typography variant="body2" align="left">
                {data.categoryName}
              </Typography>
            </Grid>
          </Box>

          <Box marginBottom={1}>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Typography variant="subtitle2" align="left">
                Description
              </Typography>
            </Grid>
          </Box>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <Typography variant="body2" align="left">
              {data.description}
            </Typography>
          </Grid>
        </CardContent>
        <CardActions disableSpacing>
          <Grid container>
            <Grid item lg={6} md={6} sm={6} xs={6} />
            <Grid
              item
              lg={6}
              md={6}
              sm={6}
              xs={6}
              style={{ textAlign: "right", padding: "0px 30px 0px 0px" }}
            >
              {assignedContent.statusId > 0 && (
                <Typography
                  variant="caption"
                  className={classes.assignedContent}
                  component="span"
                >
                  Status:&nbsp; {getContentStatus(assignedContent.statusId)}
                </Typography>
              )}
            </Grid>
          </Grid>
        </CardActions>
      </Card>
    </Grid>
  );
};

MoneyHack.propTypes = {
  data: PropTypes.shape({
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    categoryName: PropTypes.string.isRequired,
  }),
  assignedContent: PropTypes.shape({
    statusId: PropTypes.number,
    assignedAt: PropTypes.string,
  }),
};

MoneyHack.defaultProps = {
  data: {
    title: "",
    description: "",
    categoryName: "",
  },
  assignedContent: {
    statusId: 0,
    assignedAt: null,
  },
};
